import React from 'react';
import ResultadoListaPartidos from '../consulta/ResultadoListaPartidos.js';
import { NombreEquipoCategoria } from '../funciones/FuncionesEquipo.js';
import * as Funciones from '../funciones/FuncionesPartidos.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import styles from './PartidosEtapaTorneo.module.css';

const PartidosEtapaTorneo = (props) => {
  const categoria = props.categoria;
  const partidos = props.partidos;
  const etapa = props.etapa;

  const onPartidoElegido = (idPartido) => {
    props.onPartidoElegido(idPartido);
  };

  let partidosVisibles = [];
  let equiposLibres = [];
  if (partidos) {
    for (const partido of partidos) {
      if (partido.equipoLibre) {
        const nombreLocal =
          partido.equipoLocal && partido.equipoLocal.nombre
            ? partido.equipoLocal.nombre
            : 'Equipo desconocido';
        equiposLibres = [...equiposLibres, nombreLocal];
      } else {
        partidosVisibles = [...partidosVisibles, partido];
      }
    }
  }

  // Verificar si la etapa tiene fechas
  const etapaTieneFechas = etapa && etapa.cantidadFechas && etapa.cantidadFechas > 0;

  // Si no tiene fechas, agrupar por instancia
  let partidosPorInstancia = {};
  let instancias = [];
  if (!etapaTieneFechas && partidosVisibles.length > 0) {
    partidosVisibles.forEach((partido) => {
      const instancia = partido.instancia || 'Unico';
      if (!partidosPorInstancia[instancia]) {
        partidosPorInstancia[instancia] = [];
        instancias.push(instancia);
      }
      partidosPorInstancia[instancia].push(partido);
    });
  }

  // Función para renderizar una tabla de partidos
  const renderTablaPartidos = (partidosGrupo, mostrarFecha, tituloInstancia = null) => (
    <React.Fragment>
      {tituloInstancia && tituloInstancia !== 'Unico' && (
        <div className={`${styles.tituloInstancia}`}>{tituloInstancia}</div>
      )}
      <table className={`${styles.tabla_partidos}`}>
        <thead>
          <tr>
            {mostrarFecha && <th>Fec.</th>}
            <th>Día</th>
            <th>Local</th>
            <th>Result</th>
            <th>Visitante</th>
          </tr>
        </thead>
        <tbody>
          {partidosGrupo.map((partido) => (
            <tr key={partido.id}>
              {mostrarFecha && (
                <td className={`${styles.nroFecha}`}>
                  {Funciones.DetalleFecha(partido.nroFecha, partido.instancia)}
                </td>
              )}
              <td className={`${styles.fecha}`}>
                {FuncionesFecha.CamposToFechaCorta(
                  partido.anioPartido,
                  partido.mesPartido,
                  partido.diaPartido
                )}
              </td>
              <td className={`${styles.equipo}`}>
                {NombreEquipoCategoria(
                  partido.equipoLocal.nombre,
                  partido.equipoLocal.categoria,
                  categoria
                )}
              </td>
              <td className={`${styles.result}`}>
                <ResultadoListaPartidos
                  id={partido.id}
                  onPartidoElegido={onPartidoElegido}
                  local={partido.resultadoLocal}
                  visitante={partido.resultadoVisitante}
                />
              </td>
              <td className={`${styles.equipo}`}>
                {NombreEquipoCategoria(
                  partido.equipoVisitante.nombre,
                  partido.equipoVisitante.categoria,
                  categoria
                )}
              </td>
            </tr>
          ))}
          {equiposLibres &&
            equiposLibres.map((nombre, index) => (
              <tr key={`libre-${index}`}>
                <td colSpan={mostrarFecha ? '5' : '4'} className={`${styles.equipo}`}>
                  {`Libre: ${nombre}`}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {etapaTieneFechas || instancias.length === 0 ? (
        // Si tiene fechas o no hay instancias, mostrar tabla normal con columna Fec.
        renderTablaPartidos(partidosVisibles, true)
      ) : instancias.length === 1 && instancias[0] === 'Unico' ? (
        // Si solo hay instancia "Unico", mostrar sin columna Fec. y sin título
        renderTablaPartidos(partidosVisibles, false)
      ) : (
        // Si hay múltiples instancias, mostrar una tabla por cada instancia
        <div className={`${styles.contenedorInstancias}`}>
          {instancias.map((instancia) => (
            <div key={instancia} className={`${styles.grupoInstancia}`}>
              {renderTablaPartidos(partidosPorInstancia[instancia], false, instancia)}
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default PartidosEtapaTorneo;
